import type { ReactNode } from "react"

import { motion, useReducedMotion } from "motion/react"

import { cn } from "@/lib/utils"

export function FadeIn({
  children,
  delay = 0,
  duration = 0.2,
  className,
}: {
  children: ReactNode
  delay?: number
  duration?: number
  className?: string
}) {
  const reduceMotion = useReducedMotion()

  return (
    <motion.div
      initial={reduceMotion ? undefined : { opacity: 0, y: 8 }}
      animate={reduceMotion ? undefined : { opacity: 1, y: 0 }}
      transition={{ duration, ease: "easeOut", delay }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
